import React from "react";
import { imageLink } from "../../actions/utility";
import emptyUserImg2 from "../../public/images/empty.svg";

const scoresArray = [
  {
    id: 1,
    score: "95%",
    name: "Ayan Shah",
    image:
      "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/lmprofile_1659690725_up_365300652.jpeg",
  },
  {
    id: 2,
    score: "93%",
    name: "Aaniyah Eraj",
    image:
      "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/lmprofile_1652856846_up_765775947.jpeg",
  },
  {
    id: 3,
    score: "91%",
    name: "Sophie Saleem",
    image:
      "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/lmprofile_1601285083_up_66450683.jpeg",
  },
  {
    id: 4,
    score: "90%",
    name: "Dania Noor",
    image:
      "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/lmprofile_1650440976_up_644287244.jpeg",
  },
  {
    id: 5,
    score: "85%",
    name: "Marium Tahir",
    image:
      "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/lmprofile_1652681452_up_600926738.jpeg",
  },
];

const ScoresLeaderBoard = ({ scoresData }) => {
  console.log("Other Students", scoresData);
  return scoresData
    ? scoresData.length > 0 && (
        <div className="pb-2 pl-3 mt-3" style={{ background: "#edf0f3" }}>
          <label>Quiz score:</label>

          {scoresData &&
            scoresData.map((item, index) => (
              <div className="d-flex mt-2" key={index}>
                <img
                  src={item.image ? imageLink(item.image) : emptyUserImg2}
                  width="40"
                  height="40"
                  className="rounded-circle"
                />
                <label className="my-auto ml-2">
                  <span className="font-weight-bold">{item.user_name}</span> scored{" "}
                  <span className="font-weight-bold text-success">{item.score}%</span>{" "}
                </label>
              </div>
            ))}
        </div>
      )
    : null;
};

export default ScoresLeaderBoard;
